import { createFileRoute, redirect } from '@tanstack/react-router';
import type { AuthContextType } from '@/features/auth';
import { LoginPage } from '@/features/auth';
import * as authLib from '@/lib/auth';
import { getHomeRedirectTarget } from '@/lib/home-redirect';

export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => {
    const auth = (context as { auth: AuthContextType }).auth;

    // Check localStorage directly for immediate auth state after login
    const isAuthenticated = authLib.isAuthenticated();
    const storedUser = authLib.getStoredUser();
    const roles = storedUser?.roles || auth?.user?.roles || [];

    // If already authenticated, redirect to appropriate dashboard
    if ((isAuthenticated && auth?.user) || (isAuthenticated && storedUser)) {
      const redirectTarget = getHomeRedirectTarget({ isAuthenticated, roles });
      throw redirect({ to: redirectTarget, replace: true });
    }
  },
  component: LoginPage,
});
